import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideHttpClient } from '@angular/common/http';
import { appReducers } from './store/app.reducer';
import { provideEffects } from '@ngrx/effects';
import { metaReducers } from './store/app.meta-reducers';
import { provideStore } from '@ngrx/store';
import { AuthEffects } from './store/auth/auth.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore(appReducers, { metaReducers }),
    provideEffects(AuthEffects),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(),
    provideStoreDevtools({ maxAge: 25, logOnly: false }),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
};
